/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m16.276 15.172-3.861-3.54V7.416a.833.833 0 1 0-1.666 0v4.582c0 .234.097.457.27.615L15.15 16.4a.842.842 0 0 0 1.178-.051.833.833 0 0 0-.052-1.177Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.999 2C6.477 2 2 6.476 2 11.998a9.973 9.973 0 0 0 3.358 7.474l1.18-1.18A8.332 8.332 0 1 1 18.292 6.538l1.177-1.179A9.986 9.986 0 0 0 12 2ZM20.47 6.693l-1.212 1.212a8.293 8.293 0 0 1 1.073 4.093 8.34 8.34 0 0 1-8.332 8.332 8.294 8.294 0 0 1-4.093-1.073L6.69 20.472A9.952 9.952 0 0 0 12 21.996c5.521 0 9.998-4.476 9.998-9.998a9.964 9.964 0 0 0-1.527-5.305Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.75 2.254a.805.805 0 0 0-1.166 0l-18.33 18.33a.805.805 0 0 0 0 1.166c.333.333.916.333 1.166 0L21.75 3.42a.805.805 0 0 0 0-1.166Z"
})), "0 0 24 24", "NoRescheduling");